<template>
    <v-card class="dialog-card">
        <div class="d-flex">
            <div class="px-6 py-5">
                <slot name="header" />
            </div>
            <v-spacer />
            <div class="pa-3">
                <icon-button
                    v-if="!isWarning"
                    icon="X"
                    @click="close_dialog()"
                />
            </div>
        </div>
        <v-card-text class="dialog-content pb-3">
            <slot />
        </v-card-text>
        <v-card-actions class="dialog-actions-bar pa-4">
            <slot name="footer" />
        </v-card-actions>
    </v-card>
</template>

<script>
import { actions } from "@/store/modules/dialog";
export default {
    name: "GeneralDialogTemplate",
    props: {
        isWarning: { type: Boolean, default: false }
    },
    setup(props, ctx) {
        const close_dialog = function() {
            ctx.emit("close");
        };

        return {
            ...actions,
            close_dialog
        };
    }
};
</script>
